<div class="card info-card right-info-box">
    <div class="row" [innerHTML]="UpdatedContent | safeHtml">
    </div>
    <div class="button-center d-flex" *ngIf="Button && Button!==''">
        <button type="submit" class="btn mt-20px btn-secondary text-uppercase" (click)="navigateTo(Url)">
            <span>{{Button}}</span>
        </button>
    </div>
</div>